import { Dialog, DialogContent, DialogTitle } from "@/components/ui/dialog";
import { X } from "lucide-react";
import { Link } from "react-router-dom";
import bookingBg from "@/assets/booking-popup-bg.jpg";

interface BookNowMenuModalProps {
  open: boolean;
  onOpenChange: (open: boolean) => void;
  onSelectCabana: () => void;
  onSelectTubing: () => void;
  onSelectGlamping: () => void;
}

export function BookNowMenuModal({ 
  open, 
  onOpenChange, 
  onSelectCabana, 
  onSelectTubing, 
  onSelectGlamping 
}: BookNowMenuModalProps) {
  return (
    <Dialog open={open} onOpenChange={onOpenChange}>
      <DialogContent className="max-w-md w-[95vw] p-0 border-0 bg-transparent">
        <DialogTitle className="sr-only">Book Your Experience</DialogTitle>
        
        {/* Background with smokey overlay */}
        <div 
          className="relative rounded-lg overflow-hidden"
          style={{ 
            backgroundImage: `url(${bookingBg})`,
            backgroundSize: 'cover',
            backgroundPosition: 'center'
          }}
        >
          {/* Smokey overlay */}
          <div className="absolute inset-0 bg-charcoal/80 backdrop-blur-sm" />
          
          {/* Close button */}
          <button
            onClick={() => onOpenChange(false)}
            className="absolute top-4 right-4 z-20 w-10 h-10 rounded-full bg-white/20 hover:bg-white/30 flex items-center justify-center transition-colors"
          >
            <X className="w-5 h-5 text-white" />
          </button>
          
          {/* Content */}
          <div className="relative z-10 p-6 md:p-8">
            <h2 className="font-lora text-2xl md:text-3xl font-bold text-white text-center mb-6">
              Book Your Experience
            </h2>
            
            {/* Menu Buttons */}
            <div className="space-y-4">
              <button
                onClick={() => {
                  onOpenChange(false);
                  onSelectCabana();
                }}
                className="w-full py-4 px-6 bg-coral-orange hover:bg-coral-orange/90 text-white font-bold text-lg rounded-lg transition-all transform hover:scale-[1.02] shadow-lg"
              >
                Book a Cabana or Picnic Table
              </button>
              
              <button
                onClick={() => {
                  onOpenChange(false);
                  onSelectTubing();
                }}
                className="w-full py-4 px-6 bg-coral-orange hover:bg-coral-orange/90 text-white font-bold text-lg rounded-lg transition-all transform hover:scale-[1.02] shadow-lg"
              >
                Rent Tubes
              </button>
              
              <button
                onClick={() => {
                  onOpenChange(false);
                  onSelectGlamping();
                }}
                className="w-full py-4 px-6 bg-coral-orange hover:bg-coral-orange/90 text-white font-bold text-lg rounded-lg transition-all transform hover:scale-[1.02] shadow-lg"
              >
                Stay Overnight
              </button>
              
              <Link
                to="/book-now"
                onClick={() => onOpenChange(false)}
                className="block w-full py-4 px-6 bg-coral-orange hover:bg-coral-orange/90 text-white font-bold text-lg rounded-lg transition-all transform hover:scale-[1.02] shadow-lg text-center"
              >
                See All Properties
              </Link>
            </div>
          </div>
        </div>
      </DialogContent>
    </Dialog>
  );
}
